import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";

import { App } from "./App";
import { Operations } from "./views/Operations";
import { ProjectDetail } from "./views/ProjectDetail";
import { Projects } from "./views/Projects";
import { RunDetailView } from "./views/RunDetail";
import { RunList } from "./views/RunList";
import { Unauthorized } from "./api";
import "./styles.css";

/**
 * **`refetchInterval` is never set here.**
 *
 * As a client default it would make every open artifact re-download from the
 * object store every few seconds. Polling is set per-query, on the run and
 * attempt views only, and stops when the server says the row is terminal.
 */
const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      retry: (failureCount, error) =>
        // 401 is an auth boundary, not a transient failure. Retrying it three
        // times against a session that is gone just delays the redirect.
        !(error instanceof Unauthorized) && failureCount < 2,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<RunList />} />
            <Route path="runs/:runId" element={<RunDetailView />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:projectId" element={<ProjectDetail />} />
            <Route path="operations" element={<Operations />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
